module.exports = __webpack_public_path__ + "static/media/04.b4e753cf.png";